import { Fragment, ReactNode } from 'react'

const toToken = (name: string) => `__${name}__`

export const nodeTokens = (names: string[]) =>
  names.reduce<Record<string, string>>(
    (acc, name) => ({ ...acc, [name]: toToken(name) }),
    {}
  )

export const interpolateNodes = (
  text: string,
  nodes: Record<string, ReactNode>
): ReactNode => {
  const names = Object.keys(nodes)
  if (!names.length) return text

  const parts = text.split(new RegExp(`(${names.map(toToken).join('|')})`))

  return parts.map((part, index) => {
    const name = names.find((item) => toToken(item) === part)

    return <Fragment key={index}>{name ? nodes[name] : part}</Fragment>
  })
}
